// @ts-ignore
import Cookies from "js-cookie";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getBacket } from "~/redux/action-creaters/basket";
import { resetSdekData, setParams } from "~/redux/action-creaters/cart";
import { getUser } from "~/redux/action-creaters/user";
import { UserFields } from "~/types/cart";
import { safeLocalStorage } from "~/utils/safeStorage";

type RootState = any;

export const getCartParamsFromStore = () => {
  let cartParams;
  try {
    cartParams = JSON.parse(safeLocalStorage.getItem("cartParams") || "{}");
  } catch (e) {
    console.log(e);
  }
  return cartParams;
};

export const setCartParamsToStore = (cartParams: any) =>
  safeLocalStorage.setItem("cartParams", JSON.stringify(cartParams));

export function useCartInitLogic(isMain = false) {
  const dispatch = useDispatch();

  const { isParamsLoaded, isBasketLoaded, params } = useSelector(
    (state: RootState) => state.cart,
  );

  const { cityName, deliveryCityData } = useSelector(
    (state: RootState) => state.location,
  );
  const { user, isUserLoaded } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    if (isMain) {
      dispatch(getUser());
      dispatch(getBacket(true));
    }
  }, []);

  useEffect(() => {
    if (isParamsLoaded) {
      setCartParamsToStore(params);
    }
  }, [isParamsLoaded, params]);

  const updateCartLocation = (
    cityName: string,
    deliveryCityData: Record<string, string> = {},
  ) => {
    let cartParams = getCartParamsFromStore();

    cartParams = {
      [UserFields.name]: cartParams[UserFields.name],
      [UserFields.phone]: cartParams[UserFields.phone],
      [UserFields.email]: cartParams[UserFields.email],
      [UserFields.isNeedInstall]: cartParams[UserFields.isNeedInstall],
      [UserFields.city]: [
        cityName,
        deliveryCityData.region_with_type,
        deliveryCityData.kladr_id,
      ]
        .filter(Boolean)
        .join(", "),
      city_name: cityName,
      region_name: deliveryCityData.region_with_type,
      kladr_id: deliveryCityData.kladr_id,
      postal_code: deliveryCityData.postal_code,
    };

    dispatch(resetSdekData());
    dispatch(setParams(cartParams));

    return cartParams;
  };

  useEffect(() => {
    if (
      !isParamsLoaded &&
      isMain &&
      isUserLoaded &&
      isBasketLoaded &&
      cityName
    ) {
      let cartParams = getCartParamsFromStore();

      if (
        !cartParams.city_name ||
        cartParams[UserFields.city] === "Россия" ||
        cartParams.city_name === "Россия"
      ) {
        if (cityName === "Россия") {
          try {
            const cookieCityName = Cookies.get("cityName");
            if (cookieCityName) {
              const deliveryCityDataJson = Cookies.get("deliveryCityData");
              let cookieDeliveryCityData = {};
              if (deliveryCityDataJson) {
                cookieDeliveryCityData = JSON.parse(deliveryCityDataJson);
              }
              cartParams = updateCartLocation(
                cookieCityName,
                cookieDeliveryCityData,
              );
            }
          } catch {
            /* empty */
          }
        } else {
          cartParams = updateCartLocation(cityName, deliveryCityData);
        }
      }
      if (user?.ID) {
        if (user.PHONE && !cartParams[UserFields.phone]) {
          cartParams[UserFields.phone] = user.PHONE;
        }
        if (
          user.NAME &&
          !cartParams[UserFields.name] &&
          user.NAME !== "new user"
        ) {
          cartParams[UserFields.name] = user.NAME;
        }
        if (
          user.EMAIL &&
          !cartParams[UserFields.email] &&
          cartParams.EMAIL !== `${user.PHONE}@farkop.ru`
        ) {
          cartParams[UserFields.email] = user.EMAIL;
        }
      }
      if (
        cartParams[UserFields.deliveryId] &&
        !cartParams[UserFields.pointId]
      ) {
        delete cartParams[UserFields.deliveryId];
      }

      dispatch(setParams(cartParams));
      dispatch({ type: "SET_CART_PARAMS_LOADED", payload: true });
    }
  }, [
    isParamsLoaded,
    cityName,
    deliveryCityData,
    isUserLoaded,
    isBasketLoaded,
  ]);

  return {
    updateCartLocation,
  };
}
